import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { MatIcon } from '@angular/material/icon';
import { MatDialogTitle } from '@angular/material/dialog';

@Component({
    standalone: true,
    selector: 'app-modal-header',
    templateUrl: './modal-header.component.html',
    styleUrls: ['./modal-header.component.css'],
    imports: [MatIcon, MatDialogTitle]
})
export class ModalHeaderComponent implements OnInit {
  @Input() title;
  @Input() hasClose = false;
  @Output() handleClose = new EventEmitter();
  constructor() { }

  ngOnInit() {
  }

  close() {
    this.handleClose.emit('true');
  }
}
